<template>
  <v-col cols="6">
    <div class="card" :class="cardClass">
      <span v-if="props.type === 'ABERTO'">Vaga aberta</span>
      <span v-else> Dr Minha Escala <br />123123-SP </span>

      <div class="flex flex-col items-center">
        <span
          v-if="confirmed"
          class="legend"
          :class="{ 'line-through opacity-50': props.hideLabels }"
        >
          Confirmado
        </span>

        <span
          v-if="notConfirmed"
          class="legend"
          :class="{ 'line-through opacity-50': props.hideLabels }"
        >
          Não confirmado
        </span>

        <span
          v-if="doctorPending"
          class="legend"
          :class="{ 'line-through opacity-50': props.hideLabels }"
        >
          Pendente
        </span>
      </div>
    </div>
  </v-col>
</template>

<script setup lang="ts">
import { computed } from 'vue'

// Adicionamos 'hideLabels' nas props
const props = defineProps(['type', 'confirmed', 'notConfirmed', 'doctorPending', 'hideLabels'])

const cardClass = computed(() => {
  switch (props.type) {
    case 'ABERTO':
      return 'card card-opened'
    case 'FIXO':
      return 'card card-weekly'
    case 'COBERTURA':
      return 'card card-coverage'
    case 'EXTRA':
      return 'card card-extra'
    default:
      return 'card'
  }
})
</script>

<style scoped>
.card {
  @apply flex flex-col justify-center items-center w-full h-[110px] font-bold text-sm rounded text-white transition-all duration-300;
}
.card-opened {
  @apply bg-alert;
}
.card-weekly {
  @apply bg-primary10;
}
.card-coverage {
  @apply bg-tertiary;
}
.card-extra {
  @apply bg-feedBackSuccess;
}

.legend {
  @apply text-xs text-black font-normal transition-all duration-300;
}
</style>
